import {CustomCellRendererProps} from '@ag-grid-community/react';
import {IconMinus, IconPlus} from "@tabler/icons-react";

export type PersonToggleCellProps = CustomCellRendererProps<boolean> & {}

export const PersonToggleCell = (props: PersonToggleCellProps) => {
  const {value} = props
  return value ? <IconMinus size={14}/> : <IconPlus size={14}/>;
}
